export default {
  proxy: import.meta.env.VITE_USE_PROXY === 'true',
  dataServerUrl: import.meta.env.VITE_APP_DESIGNER_URL || '',
  belledonneConverterKey: import.meta.env.VITE_BELLEDONNE_CONVERTER_KEY || '',
  authProviderUrl: '/mbe/api/v2/login/providers/hpid',
  passportEndpoint: '/mbe/api/v2/access/token/by/passport',
  authSessionUrl: '/form/view/839',
  identityService: import.meta.env.VITE_SERVICE_IDENTITY || '',
  sitebuilderService: import.meta.env.VITE_SERVICE_SITEBUILDER || '',
  appIdentifier: {
    domain: 'localhost',
    id: import.meta.env.VITE_APP_ID || '',
    ownerId: import.meta.env.VITE_OWNER_ID || '',
  },
  kbaseService: {
    httpServer: import.meta.env.VITE_HTTPS_KBASE,
  },
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  sitePagesSettings: [
    {
      name: 'default',
      template: 'hpscm/components/layout/LayoutMain',
      properties: {
        withPadding: {
          type: 'boolean',
          description: 'Add paddings to the layout',
        },
        withSearch: {
          type: 'boolean',
          description: 'Show search bar',
        },
        noFooter: {
          type: 'boolean',
          description: 'Hide footer',
        },
      },
    },
    {
      name: 'clean',
      template: 'src/core/layout/LayoutClean',
      properties: {},
    },
  ],
}
